import React from 'react';

//images
import Close from 'css/images/close.svg';

const AlertModal = ({ title, text, onClose }) => {
	return (
		<div className="body-alert">
			<div className="custom-alert">
				<div className="alert-header">
					<div className="head-deco">
						<img src={Close} onClick={onClose} alt="Cerrar" />
					</div>
				</div>
				<div className="alert-body">
					<h2>{title}</h2>
					<p>{text}</p>
					<button onClick={onClose}>ACEPTAR</button>
				</div>
			</div>
		</div>
	);
};

export default AlertModal;
